import { NgModule } from '@angular/core';
import { DateFormatPipe } from './date-format.pipe';  // Adjust path to the pipe
import { AddPipe } from './time-format.pipe';

@NgModule({
  declarations: [DateFormatPipe, AddPipe],
  exports: [DateFormatPipe, AddPipe]  // Export the pipe for global use
})
export class SharedPipesModule { }
